// extracted by mini-css-extract-plugin
export default {"wrap":"LegalPage_wrap__zwvmA","backgroundContainer":"LegalPage_backgroundContainer__WuQOw","contentBlock":"LegalPage_contentBlock__U0UAk"};